import { LabelValueModel } from './../models/shared/labelValue.model';
import { InsuranceParamGroup, InsuranceParamType, ProductClass, SaleTypeFilter, SaleVehicleType, VehicleClass, WorkflowAction, WorkflowStatus } from './../utility/enums';
import { SaleResultModel } from './../models/dms/saleResult.model';
import { DocumentModel } from 'app/models/dms/document.model';
import { CacheService } from './cache.service';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { TabModel } from 'app/models/shared/tab.model';
import { UserService } from 'app/services/user.service';
import { SaleModel } from 'app/models/dms/sale.model';
import { SaleSearchResultModel } from 'app/models/dms/saleSearchResult.model';
import { SaleSearchParamsModel } from 'app/models/dms/saleSearchParams.model';

import { FieldModel } from 'app/models/shared/field.model';
import { SecurityRight } from 'app/utility/enums';

import { Injectable } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';

import { Constants } from 'app/utility/constants';
import { StorageService } from 'app/services/storage.service';
import { SaleDetails_Customer, SaleDetails_General, SaleDetails_Payment, SaleDetails_Payments, SaleDetails_SaleProduct, SaleDetails_Summary, SaleDetails_Vehicle, SaleDetails_Vehicles, SaleDetailsModel } from 'app/models/dms/saleDetails.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { SingleDocumentUploadModel } from 'app/models/shared/documentUpload.model';
import { GeneralService } from './general.service';
import { PriceEditorModel } from 'app/models/shared/priceEditor.model';
import { DateHelper } from 'app/utility/datehelper';
import { CustomFieldDisplayModel } from 'app/models/shared/customField.model';
import { TasksSearchResult } from 'app/models/dms/tasksSearchResult.model';
import { MoneyOutstandingSearchParamsModel } from 'app/models/dms/moneyOutstandingSearchParams.model';
import { MoneyOutstandingSearchResult } from 'app/models/dms/moneyOutstandingSearchResult.model';
import { InsuranceParamModel, InsuranceProviderManuModelVariantModel, InsuranceProviderValidationModel } from 'app/models/dms/insuranceProviderValidation.model';
import { SaleProductsSearchResult } from 'app/models/dms/saleProductsSearchResult.model';
import { SaleProductsSearchParamsModel } from 'app/models/dms/saleProductsSearchParams.model';
import { LookupExternalModel } from 'app/models/shared/lookup.model';
import { ProductQuoteModel, ProductQuoteMviProductModel } from 'app/models/dms/productQuote.model';


@Injectable({
	providedIn: 'root'
})
export class SaleService
{
	public saleMessage = new Subject<SaleDetailsModel>(); // Add this Subject

	constructor(
		private httpClient: HttpClient,
		private userService: UserService,
		private cache: CacheService,
		private storage: StorageService,
		private generalService: GeneralService,
	) { }

	getSales(searchParams: SaleSearchParamsModel): Observable<SaleSearchResultModel>
	{
		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient.get<SaleSearchResultModel>(Constants.ApiUrl + 'sales/search', { params: httpParams });
	}

	getSalesIndex(saleStatusEnum: string, salespersonId: string, dealershipId: string): Observable<string[]>
	{
		let httpParams = new HttpParams();

		httpParams = httpParams.append('saleStatusEnum', saleStatusEnum);
		httpParams = httpParams.append('salespersonId', salespersonId);
		httpParams = httpParams.append('dealershipId', dealershipId);
		return this.httpClient.get<string[]>(Constants.ApiUrl + 'sales/index', { params: httpParams });
	}


	getQuoteById(id: string, loadActivities: boolean = false): Observable<SaleModel>
	{
		let httpParams = new HttpParams();
		// httpParams = httpParams.append('loadActivities', loadActivities ? "true" : "false");
		return this.httpClient.get<SaleModel>(Constants.ApiUrl + 'Quotes/' + id, { params: httpParams });
	}

	getQuotationPdf(id: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(Constants.ApiUrl + 'Quotes/' + id + "/pdf", { params: httpParams, responseType: "blob" });
	}

	getQuotationPdfUrl(id: string): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<LabelValueModel>(Constants.ApiUrl + 'Quotes/' + id + "/url", { params: httpParams });
	}

	getSaleById(id: string, loadActivities: boolean = false): Observable<SaleModel>
	{
		let httpParams = new HttpParams();
		// httpParams = httpParams.append('loadActivities', loadActivities ? "true" : "false");
		return this.httpClient.get<SaleModel>(Constants.ApiUrl + 'Sales/' + id, { params: httpParams });
	}

	getSalePdf(id: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(Constants.ApiUrl + 'Sales/' + id + "/pdf", { params: httpParams, responseType: "blob" });
	}

	getSalePdfUrl(id: string): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<LabelValueModel>(Constants.ApiUrl + 'Sales/' + id + "/url", { params: httpParams });
	}

	seedCache(): void
	{
		let cacheKey: string = 'seedSalesProductCache';
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		this.cache.get(cacheKey, this.seedCacheInternal(), cacheMilliseconds).subscribe(x => { });
	}
	private seedCacheInternal(): Observable<any>
	{
		// console.log("Seeding the sales products cache");
		return this.httpClient.get(Constants.ApiUrl + 'Sales/SeedCache', {});
	}

	public setupFieldGroups(sale: SaleModel, isSale: boolean = false, editActive: boolean = false, makeDirty: boolean = false, disableClone: boolean = false): TabModel[]
	{
		var fieldGroupTabs: TabModel[] = [];

		if (this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary) && sale && !editActive)
		{
			fieldGroupTabs.push(new TabModel("Summary", sale, this.getFieldGroups(sale, "Summary"), makeDirty, "summary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}
		if (this.userService.hasUserRight(SecurityRight.SaleTabsFinanceView) && sale && !editActive)
		{
			if (sale.financeSummary && sale.financeSummary.total)
			{
				fieldGroupTabs.push(new TabModel("Finance Summary", sale, this.getFieldGroups(sale, "Finance Summary"), makeDirty, "financesummary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
			}
			if (sale.financeCentralSummary)
			{
				fieldGroupTabs.push(new TabModel("Avanti Finance", sale, this.getFieldGroups(sale, "Avanti Finance"), makeDirty, "financecentral", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
			}
		}
		if (this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView) && !editActive)
		{
			fieldGroupTabs.push(new TabModel("General", sale, this.getFieldGroups(sale, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
			fieldGroupTabs.push(new TabModel("Customer" + (sale.customers.length > 1 ? "s" : ""), sale, this.getFieldGroups(sale, "Customers"), makeDirty, "customers", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}

		if (this.userService.hasUserRight(SecurityRight.SaleTabsNotesView) &&
			this.userService.mcMinVersion("3.2.10"))
		{
			fieldGroupTabs.push(new TabModel("Delivery", sale, this.getFieldGroups(sale, "Delivery"), makeDirty, "delivery", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), false));

			fieldGroupTabs.push(new TabModel("Notes", sale, this.getFieldGroups(sale, "Notes"), makeDirty, "notes", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), false));
		}
		return fieldGroupTabs;
	}


	public getFieldGroups(sale: SaleModel, groupId: string): FieldGroupModel[]
	{
		var field_groups = [];
		var group: FieldGroupModel;
		switch (groupId)
		{
			case "General":
				group = new FieldGroupModel("Summary");
				group.addField(new FieldModel("Sale No.", sale.saleNo, "text"));
				group.addField(new FieldModel("Date of Sale ", sale.saleDate, "date"));
				group.addField(new FieldModel("Sale Status", sale.saleStatusEnum, "lookup", "saleStatusEnum", false, null, sale.saleStatus));
				group.addField(new FieldModel("Dealership", sale.company.name, "text"));

				group.addField(new FieldModel("Salesperson", sale.salesPersonId, "contact", "salesPersonId", false, null, sale.salesPerson));
				group.addField(new FieldModel("Business Manager", sale.busManagerId, "contact", "busManagerId", false, null, sale.busManager));
				group.addField(new FieldModel("Referral Method", sale.referralMethodId, "lookup", "referralMethodId", false, null, sale.referralMethod));
				group.addField(new FieldModel("Sale Type", sale.saleTypeEnum, "lookup", "saleTypeEnum", false, null, sale.saleType));
				field_groups.push(group);
				for (var i = 0; i < 2; i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				break;
			case "Customers":
				group = new FieldGroupModel("Customer" + (sale.customers.length > 1 ? "s" : ""));
				sale.customers.forEach(function (customer)
				{
					// console.log(customer);
					// group = new FieldGroupModel("Customer ");
					group.addField(new FieldModel("Name", customer.id, "contact", "contactId", false, false, customer));

				});
				for (var i = 0; i < (8 - sale.customers.length); i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				field_groups.push(group);

				break;

			case "Summary":
				group = new FieldGroupModel("Sale Summary");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Vehicles sold", sale.summarySaleVehiclesSoldAmount, "currency"), "toppadding");
				this.addCurrencyField(group, new FieldModel("Registration", sale.summaryVehicleRegistrationAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Vehicle insurance", sale.summaryVehicleInsuranceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("MBI/Warranty", sale.summaryBreakdownInsuranceAmount, "currency"));
				// this.addCurrencyField(group, new FieldModel("Service plan", sale.summaryVehicleServicePlanAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("LPI/PPI & GAP cover", (sale.summaryPaymentInsuranceAmount + sale.summaryEquityInsuranceAmount), "currency"));
				this.addCurrencyField(group, new FieldModel("Sale extras", sale.summaryProductAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Subtotal", sale.summarySaleSubTotalAmount, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Less Net Trade(s)", sale.summarySaleNetTradeInsAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Net Total", sale.summaryBalanceNetPrice, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Cash installments", sale.summaryBalanceCashInstallments, "currency"));
				this.addCurrencyField(group, new FieldModel("Amount to finance", sale.summaryFinanceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Unallocated", sale.summaryBalanceUnallocated, "currency"), "bold " + (sale.summaryBalanceUnallocated > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Payments to date", sale.salePaymentsTotalAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Money outstanding", sale.summaryFinanceOutstandingAmount, "currency"), "bold nounderline " + (sale.summaryFinanceOutstandingAmount > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				group.addField(new FieldModel(" ", " ", "text"));
				field_groups.push(group);
				break;
			case "Sold Vehicles":
				group = new FieldGroupModel("Vehicles Sold");
				sale.vehiclesSold.forEach(function (vehicle)
				{
					group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
				});
				for (var i = 0; i < (10 - sale.vehiclesSold.length); i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				field_groups.push(group);
				break;

			case "Trade Ins":
				group = new FieldGroupModel("Vehicles Purchased");
				group.singleColumn = true;
				sale.vehiclesPurchased.forEach(function (vehicle)
				{
					group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
				});
				for (var i = 0; i < (10 - sale.vehiclesPurchased.length); i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				field_groups.push(group);
				break;
			case "Avanti Finance":
			case "Finance Central":
				group = new FieldGroupModel("Avanti Finance");

				group.addField(new FieldModel("Reference", sale.financeCentralSummary.reference, "text"));
				group.addField(new FieldModel("Status", sale.financeCentralSummary.status, "text"));
				if (sale.financeCentralSummary.total)
				{

					group.addField(new FieldModel("Total Financed", sale.financeCentralSummary.total, "currency", null, false, false, null, " dollar zeros"));
				}
				if (sale.financeCentralSummary.repayments)
				{
					group.addField(new FieldModel("Repayments", sale.financeCentralSummary.repayments, "text"));
				}
				if (sale.financeCentralSummary.link)
				{
					var label = (sale.financeCentralSummary.link.includes("financecentral.co.nz") ? "View in Avanti Finance" : "View application");

					group.addField(new FieldModel("Finance Application", label, "url", "financeurl", false, false, sale.financeCentralSummary.link));
				}
				for (var i = 0; i < 6; i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				field_groups.push(group);
				break;
			case "Finance Summary":
				group = new FieldGroupModel("Finance Summary");
				group.singleColumn = true;
				group.classes = "";
				var totalX = new FieldModel(sale.financeSummary.company ? sale.financeSummary.company : "Total", sale.financeSummary.total, "currency");
				totalX.sublabel = sale.financeSummary.termCaption;
				this.addCurrencyField(group, totalX, "underline");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.classes = "";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Interest", sale.financeSummary.interest, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Cost of Finance", sale.financeSummary.cost, "currency"), "underline");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Monthly", sale.financeSummary.repaymentMonthly, "currency"), "bold nounderline");
				this.addCurrencyField(group, new FieldModel("Fortnightly", sale.financeSummary.repaymentFortnightly, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Weekly", sale.financeSummary.repaymentWeekly, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Week (48)", sale.financeSummary.repaymentWeek48, "currency"), "");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.singleColumn = true;
				for (var i = 0; i < 3; i++)
				{
					group.addField(new FieldModel(" ", " ", "text"));
				}
				field_groups.push(group);
				break;
			case "Delivery":
				group = new FieldGroupModel("Delivery details");
				group.addField(new FieldModel("Delivery status", sale.deliveryStatusEnum, "lookup", "deliveryStatusEnum", false, null, sale.deliveryStatus));
				group.addField(new FieldModel("Delivery by", sale.deliveryStartByReference, "contact", "deliveryStartByReference", false, null, sale.deliveryStartBy));
				group.addField(new FieldModel("Delivery Date & Time", sale.delStartDate, "datetime", "delStartDate", true, true));
				group.addField(new FieldModel("Delivery Instructions", sale.delComment, "longtext", "delComment", true, true));
				field_groups.push(group);
				group = new FieldGroupModel("Delivery checklist");
				group.addField(new FieldModel("Checklist", sale.deliveryItemIds, "lookups", "deliveryItemIds", true, false, sale.deliveryItems, '', VehicleClass.None));
				group.addField(new FieldModel("Checked by", sale.deliveryEndByReference, "contact", "deliveryEndByReference", true, null, sale.deliveryEndBy));
				group.addField(new FieldModel("Checked date", sale.delEndDate, "datetime", "delEndDate", true, null, sale.delEndDate));
				field_groups.push(group);
				break;
			case "Checklist":
				group = new FieldGroupModel("Delivery checklist");
				var checklistField = new FieldModel("Checklist", sale.deliveryItemIds, "lookups", "deliveryItemIds", true, false, sale.deliveryItems, '', VehicleClass.None)
				checklistField.launchOnLoad = true;
				group.addField(checklistField);
				field_groups.push(group);
				break;
			case "Notes":
				group = new FieldGroupModel("Notes");
				group.addField(new FieldModel("Special conditions", sale.description, "longtext", "description", false));
				group.addField(new FieldModel("Internal notes", sale.comment, "longtext", "comment", true, false));
				group.addField(new FieldModel("Delivery by", sale.uninvitedDirectSale, "boolean", "deliveryStartByReference", false, null, sale.deliveryStartBy));
				group.addField(new FieldModel("Delivery Date & Time", sale.delStartDate, "datetime", "delStartDate", true, true));
				group.addField(new FieldModel("Delivery Instructions", sale.delComment, "longtext", "delComment", true, true));
				field_groups.push(group);
				break;
		}
		return field_groups;
	}

	public getCurrencyField(field: FieldModel, extraclass: string = "")
	{
		field.oneline = true;
		field.classes = "compactrow dollar zeros " + extraclass;
		return field;
	}

	public addCurrencyField(group: FieldGroupModel, field: FieldModel, extraclass: string = "")
	{
		if (!field.value)
		{
			field.value = "0";
		}
		group.addField(this.getCurrencyField(field, extraclass));
		// }
	}

	public getSaleDocuments(saleId: string): Observable<DocumentModel[]>
	{
		return this.httpClient.get<DocumentModel[]>(Constants.ApiUrl + 'Sales/' + saleId + "/Documents");
	}

	public getSaleDocument(saleId: string, documentURI: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get(Constants.ApiUrl + 'Sales/' + saleId + "/Document", { params: httpParams, responseType: "blob" });
	}
	public getSaleDocumentUrl(saleId: string, documentURI: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get<string>(Constants.ApiUrl + 'Sales/' + saleId + "/DocumentUrl", { params: httpParams });
	}


	requestDigitalSigning(id: string): Observable<SaleModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.patch<SaleModel>(Constants.ApiUrl + 'Sales/' + id + '/RequestDigitalSigningForSale', httpParams);
	}

	revokeDigitalSigning(id: string, cancellationReason: string): Observable<SaleModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('cancellationReason', cancellationReason);
		return this.httpClient.patch<SaleModel>(Constants.ApiUrl + 'Sales/' + id + '/RevokeDigitalSigningForSale', httpParams);
	}

	requestDigitalSigningV2(id: string): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + id + '/RequestDigitalSigningForSaleV2', httpParams);
	}

	revokeDigitalSigningV2(id: string, cancellationReason: string): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('cancellationReason', cancellationReason);
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + id + '/RevokeDigitalSigningForSaleV2', httpParams);
	}

	public validEmail(email: string): boolean
	{
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	}


	public saveRecentSale(sale: SaleResultModel)
	{
		this.storage.get(Constants.IonicStorage_RecentSales).then((val) =>
		{
			var recentSales = JSON.parse(val);
			if (!recentSales || !Array.isArray(recentSales))
			{
				recentSales = [];
			}
			else
			{
				recentSales = recentSales.filter(item => item.saleId !== sale.saleId); //remove sale if it is there already
				// console.log("here");
				// console.log(recentSales);
			}
			recentSales.unshift(sale);

			if (recentSales.length > 10)
			{
				recentSales = recentSales.slice(0, 10);
			}
			this.storage.set('recent-sales', JSON.stringify(recentSales));

		});
	}

	saveDeliveryChecklist(sale: SaleModel, checklistIds: string[]): Observable<SaleModel>
	{
		// console.log(checklistIds);
		return this.httpClient.patch<SaleModel>(Constants.ApiUrl + 'Sales/' + sale.saleId + '/DeliveryChecklist', checklistIds);
	}

	saveDeliveryChecklistV2(saleDetails: SaleDetailsModel, checklistIds: string[]): Observable<SaleDetailsModel>
	{
		// console.log(checklistIds);
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleDetails.saleId + '/DeliveryChecklistV2', checklistIds);
	}

	submitFinanceApplication(isDealerLedApplication: boolean): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('isDealerLedApplication', isDealerLedApplication ? "true" : "false");
		return this.httpClient.post<LabelValueModel>(Constants.ApiUrl + 'Dealbuilder/SubmitFinanceApplication', httpParams);
	}

	getSaleRecordById(id: string): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<SaleDetailsModel>(`${Constants.ApiUrl}Sales/sale/${id}`, { params: httpParams });
	}

	public setupFieldGroupsV2(saleDetails: SaleDetailsModel, isSale: boolean = false, editActive: boolean = false, makeDirty: boolean = false, disableClone: boolean = false): TabModel[]
	{
		// console.log("setupFieldGroupsV2");

		var fieldGroupTabs: TabModel[] = [];

		if (this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary) && saleDetails && !editActive)
		{
			let summaryFieldGroups = this.getFieldGroupsV2(saleDetails, "Summary");
			console.debug("summaryFieldGroups", summaryFieldGroups);
			fieldGroupTabs.push(new TabModel("Summary", saleDetails, summaryFieldGroups, makeDirty, "summary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}
		if (this.userService.hasUserRight(SecurityRight.SaleTabsFinanceView) && saleDetails && !editActive)
		{
			if (saleDetails.summary.financeSummary && saleDetails.summary.financeSummary.total)
			{
				fieldGroupTabs.push(new TabModel("Finance Summary", saleDetails, this.getFieldGroupsV2(saleDetails, "Finance Summary"), makeDirty, "financesummary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
			}
			if (saleDetails.summary.financeCentralSummary && saleDetails.summary.financeCentralSummary.total)
			{
				fieldGroupTabs.push(new TabModel("Avanti Finance", saleDetails, this.getFieldGroupsV2(saleDetails, "Avanti Finance"), makeDirty, "financecentral", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
			}
		}
		if (this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView) && !editActive)
		{
			fieldGroupTabs.push(new TabModel("General", saleDetails, this.getFieldGroupsV2(saleDetails, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}
		// if (this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView) && editActive)
		// {
		// 	fieldGroupTabs.push(new TabModel("Customer" + (saleDetails.general.customers.length > 1 ? "s" : ""), saleDetails, this.getFieldGroupsV2(saleDetails, "Customers"), makeDirty, "customers", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		// }
		if (this.userService.hasUserRight(SecurityRight.SaleTabsFooterView) && !editActive)
		{
			fieldGroupTabs.push(new TabModel("Status", saleDetails, this.getFieldGroupsV2(saleDetails, "Status"), makeDirty, "status", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}

		if (this.userService.hasUserRight(SecurityRight.SaleTabsNotesView))
		{
			fieldGroupTabs.push(new TabModel("Delivery", saleDetails, this.getFieldGroupsV2(saleDetails, "Delivery"), makeDirty, "delivery", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), false));

			fieldGroupTabs.push(new TabModel("Notes", saleDetails, this.getFieldGroupsV2(saleDetails, "Notes"), makeDirty, "notes", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), false));
		}
		// console.log("fieldGroupTabs", fieldGroupTabs);
		return fieldGroupTabs;
	}

	public getFieldGroupsV2(sale: SaleDetailsModel, groupId: string): FieldGroupModel[]
	{
		var field_groups = [];
		var group: FieldGroupModel;
		switch (groupId)
		{
			case "Summary":
				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				const summary = sale.summary;
				this.addCurrencyField(group, new FieldModel("Vehicles sold", summary.summarySaleVehiclesSoldAmount, "currency"), "toppadding");
				this.addCurrencyField(group, new FieldModel("Registration", summary.summaryVehicleRegistrationAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Vehicle insurance", summary.summaryVehicleInsuranceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("MBI/Warranty", summary.summaryBreakdownInsuranceAmount, "currency"));
				// this.addCurrencyField(group, new FieldModel("Service plan", summary.summaryVehicleServicePlanAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("LPI/PPI & GAP cover", (summary.summaryPaymentInsuranceAmount + summary.summaryEquityInsuranceAmount), "currency"));
				this.addCurrencyField(group, new FieldModel("Sale extras", summary.summaryProductAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Subtotal", summary.summarySaleSubTotalAmount, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Less Net Trade(s)", summary.summarySaleNetTradeInsAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Net Total", summary.summaryBalanceNetPrice, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Cash installments", summary.summaryBalanceCashInstallments, "currency"));
				this.addCurrencyField(group, new FieldModel("Amount to finance", summary.summaryFinanceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Unallocated", summary.summaryBalanceUnallocated, "currency"), "bold " + (summary.summaryBalanceUnallocated > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Payments to date", summary.salePaymentsTotalAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Money outstanding", summary.summaryFinanceOutstandingAmount, "currency"), "bold nounderline " + (summary.summaryFinanceOutstandingAmount > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				group.addField(new FieldModel(" ", " ", "text"));
				field_groups.push(group);
				break;

			case "Finance Summary":
				group = new FieldGroupModel("");
				group.singleColumn = true;
				group.classes = "";
				var totalX = new FieldModel(sale.summary.financeSummary.company ? sale.summary.financeSummary.company : "Total", sale.summary.financeSummary.total, "currency");
				totalX.sublabel = sale.summary.financeSummary.termCaption;
				this.addCurrencyField(group, totalX, "underline");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.classes = "";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Interest", sale.summary.financeSummary.interest, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Cost of Finance", sale.summary.financeSummary.cost, "currency"), "underline");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Monthly", sale.summary.financeSummary.repaymentMonthly, "currency"), "bold nounderline");
				this.addCurrencyField(group, new FieldModel("Fortnightly", sale.summary.financeSummary.repaymentFortnightly, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Weekly", sale.summary.financeSummary.repaymentWeekly, "currency"), "");
				this.addCurrencyField(group, new FieldModel("Week (48)", sale.summary.financeSummary.repaymentWeek48, "currency"), "");
				field_groups.push(group);
				group = new FieldGroupModel("");
				group.singleColumn = true;
				field_groups.push(group);
				break;


			case "General":
				group = new FieldGroupModel("General");
				group.addField(new FieldModel("Sale No.", sale.saleNo, "text"));
				group.addField(new FieldModel("Date of Sale ", sale.general.saleDate, "date"));
				// group.addField(new FieldModel("Sale Status", sale.status.saleStatusEnum, "lookup", "saleStatusEnum", false, null, sale.status.saleStatus));
				group.addField(new FieldModel("Dealership", sale.general.dealershipId, "contact", "dealershipId", true, false, sale.general.dealership));
				group.addField(new FieldModel("Salesperson", sale.general.salesPersonId, "contact", "salesPersonId", false, null, sale.general.salesPerson));
				group.addField(new FieldModel("Business Manager", sale.general.busManagerId, "contact", "busManagerId", false, null, sale.general.busManager));
				group.addField(new FieldModel("Referral Method", sale.general.referralMethodId, "lookup", "referralMethodId", false, null, sale.general.referralMethod));
				field_groups.push(group);
				break;

			case "Status":
				group = new FieldGroupModel("Status");
				group.addField(new FieldModel("Sale Status", sale.status.saleStatusEnum, "lookup", "saleStatusEnum", false, null, sale.status.saleStatus));
				group.addField(new FieldModel("Sale Type", sale.status.saleTypeEnum, "lookup", "saleTypeEnum", false, null, sale.status.saleType));
				field_groups.push(group);
				break;
			case "Customers":
				group = new FieldGroupModel("Customer" + (sale.general.customers.length > 1 ? "s" : ""));
				sale.general.customers.forEach(function (customer)
				{
					// console.log(customer);
					// group = new FieldGroupModel("Customer ");
					group.addField(new FieldModel("Name", customer.customer.id, "contact", "contactId", false, false, customer.customer));

				});
				field_groups.push(group);

				break;


			// case "Sold Vehicles":
			// 	group = new FieldGroupModel("Vehicles Sold");
			// 	sale.vehiclesSold.forEach(function (vehicle)
			// 	{
			// 		group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
			// 	});
			// 	for (var i = 0; i < (10 - sale.vehiclesSold.length); i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;

			// case "Trade Ins":
			// 	group = new FieldGroupModel("Vehicles Purchased");
			// 	group.singleColumn = true;
			// 	sale.vehiclesPurchased.forEach(function (vehicle)
			// 	{
			// 		group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
			// 	});
			// 	for (var i = 0; i < (10 - sale.vehiclesPurchased.length); i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;
			// case "Finance Central":
			// 	group = new FieldGroupModel("Finance Central");

			// 	group.addField(new FieldModel("Reference", sale.financeCentralSummary.reference, "text"));
			// 	group.addField(new FieldModel("Status", sale.financeCentralSummary.status, "text"));
			// 	if (sale.financeCentralSummary.total)
			// 	{

			// 		group.addField(new FieldModel("Total Financed", sale.financeCentralSummary.total, "currency", null, false, false, null, " dollar zeros"));
			// 	}
			// 	if (sale.financeCentralSummary.repayments)
			// 	{
			// 		group.addField(new FieldModel("Repayments", sale.financeCentralSummary.repayments, "text"));
			// 	}
			// 	if (sale.financeCentralSummary.link)
			// 	{
			// 		var label = (sale.financeCentralSummary.link.includes("financecentral.co.nz") ? "View in Finance Central" : "View application");

			// 		group.addField(new FieldModel("Finance Application", label, "url", "financeurl", false, false, sale.financeCentralSummary.link));
			// 	}
			// 	for (var i = 0; i < 6; i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;
			case "Delivery":
				group = new FieldGroupModel("Delivery details");
				group.addField(new FieldModel("Delivery status", sale.delivery.deliveryStatusEnum, "lookup", "deliveryStatusEnum", false, null, sale.delivery.deliveryStatus));
				group.addField(new FieldModel("Delivery by", sale.delivery.deliveryStartBy, "contact", "deliveryStartByReference", false, null, sale.delivery.deliveryStartBy));
				group.addField(new FieldModel("Delivery Date & Time", sale.delivery.deliveryStartDate, "datetime", "deliveryStartDate", true, true, sale.delivery.deliveryStartDate));
				group.addField(new FieldModel("Delivery Instructions", sale.delivery.deliveryInstructions, "longtext", "delComment", true, true, sale.delivery.deliveryInstructions));
				field_groups.push(group);
				if (!this.editActive)
				{
					group = new FieldGroupModel("Delivery checklist");
					group.addField(new FieldModel("Checklist", sale.delivery.deliveryItemIds, "lookups", "deliveryItemIds", true, false, sale.delivery.deliveryItems, '', VehicleClass.None));
					group.addField(new FieldModel("Checked by", sale.delivery.deliveryEndBy, "contact", "deliveryEndByReference", true, null, sale.delivery.deliveryEndBy));
					group.addField(new FieldModel("Checked date", sale.delivery.deliveryEndDate, "datetime", "delEndDate", true, null, sale.delivery.deliveryEndDate));
					field_groups.push(group);
				}
				break;
			case "Checklist":
				group = new FieldGroupModel("Delivery checklist");
				var checklistField = new FieldModel("Checklist", sale.delivery.deliveryItemIds, "lookups", "deliveryItemIds", true, false, sale.delivery.deliveryItems, '', VehicleClass.None)
				// checklistField.launchOnLoad = true;
				group.addField(checklistField);
				field_groups.push(group);
				break;
			case "Notes":
				group = new FieldGroupModel("Notes");
				group.addField(new FieldModel("Special conditions", sale.notes.specialConditions, "longtext", "description", true, false, sale.notes.specialConditions));
				group.addField(new FieldModel("Internal notes", sale.notes.internalNotes, "longtext", "comment", true, false, sale.notes.internalNotes));
				group.addField(new FieldModel("Uninvited direct sale", sale.notes, "boolean", "uninvitedDirectSale", true, false, sale.notes.uninvitedDirectSale));
				field_groups.push(group);
				break;
		}
		return field_groups;
	}

	editActive: boolean = false;
	public setupFieldGroupsV3(saleDetails: SaleDetailsModel, isExpress: boolean, isSale: boolean = false, editActive: boolean = false, makeDirty: boolean = false, disableClone: boolean = false): TabModel[]
	{

		this.editActive = editActive;

		// console.log("setupFieldGroupsV2");

		var fieldGroupTabs: TabModel[] = [];

		if (this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary) && saleDetails && !editActive && !isExpress)
		{
			let summaryFieldGroups = this.getFieldGroupsV3(saleDetails, "Summary");
			console.debug("summaryFieldGroups", summaryFieldGroups);
			fieldGroupTabs.push(new TabModel("Summary", saleDetails, summaryFieldGroups, makeDirty, "summary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		}
		// if (this.userService.hasUserRight(SecurityRight.SaleTabsFinanceView) && saleDetails && !editActive)
		// {
		// 	if (saleDetails.summary.financeSummary && saleDetails.summary.financeSummary.total)
		// 	{
		// 		fieldGroupTabs.push(new TabModel("Finance Summary", saleDetails, this.getFieldGroupsV3(saleDetails, "Finance Summary"), makeDirty, "financesummary", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		// 	}
		// 	if (saleDetails.summary.financeCentralSummary && saleDetails.summary.financeCentralSummary.total)
		// 	{
		// 		fieldGroupTabs.push(new TabModel("Avanti Finance", saleDetails, this.getFieldGroupsV3(saleDetails, "Finance Central"), makeDirty, "financecentral", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		// 	}
		// }
		if (this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView))
		{
			fieldGroupTabs.push(new TabModel("General", saleDetails.general, this.getFieldGroupsV3(saleDetails, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView), this.userService.hasUserRight(SecurityRight.SaleTabsGeneralEdit)));
		}
		// if (this.userService.hasUserRight(SecurityRight.SaleTabsGeneralView) && editActive)
		// {
		// 	fieldGroupTabs.push(new TabModel("Customer" + (saleDetails.general.customers.length > 1 ? "s" : ""), saleDetails, this.getFieldGroupsV2(saleDetails, "Customers"), makeDirty, "customers", "", this.userService.hasUserRight(SecurityRight.SaleFunctionsSummary), false));
		// }
		if (this.userService.hasUserRight(SecurityRight.SaleTabsFooterView))
		{
			fieldGroupTabs.push(new TabModel("Status", saleDetails.status, this.getFieldGroupsV3(saleDetails, "Status", isExpress), makeDirty, "status", "", this.userService.hasUserRight(SecurityRight.SaleTabsFooterView), this.userService.hasUserRight(SecurityRight.SaleTabsFooterEdit)));
		}

        if (!isExpress)
        {
            if (this.userService.hasUserRight(SecurityRight.SaleTabsExtrasView) && saleDetails.insurance)
            {
                fieldGroupTabs.push(new TabModel("Insurance", saleDetails.insurance, this.getFieldGroupsV3(saleDetails, "Insurance"), makeDirty, "insurance", "", this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsView), this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsEdit)));
            }

            if (this.userService.hasUserRight(SecurityRight.SaleTabsExtrasView) && !editActive)
            {
                fieldGroupTabs.push(new TabModel("Extras", saleDetails.extras, this.getFieldGroupsV3(saleDetails, "Extras"), makeDirty, "extras", "", this.userService.hasUserRight(SecurityRight.SaleTabsExtrasView), this.userService.hasUserRight(SecurityRight.SaleTabsExtrasEdit)));
            }

            if (this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsView))
            {
                fieldGroupTabs.push(new TabModel("Financials", saleDetails.payments, this.getFieldGroupsV3(saleDetails, "Financials"), makeDirty, "financials", "", this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsView), this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsEdit)));

            }
            if (this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsView) && !editActive)
            {
                fieldGroupTabs.push(new TabModel("Payments", saleDetails.payments, this.getFieldGroupsV3(saleDetails, "Payments"), makeDirty, "payments", "", this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsView), this.userService.hasUserRight(SecurityRight.SaleTabsPaymentsEdit)));
            }

            if (this.userService.hasUserRight(SecurityRight.SaleTabsWritebackView))
            {
                fieldGroupTabs.push(new TabModel("Writeback", saleDetails.writeback, this.getFieldGroupsV3(saleDetails, "Writeback"), makeDirty, "writeback", "", this.userService.hasUserRight(SecurityRight.SaleTabsWritebackView), this.userService.hasUserRight(SecurityRight.SaleTabsWritebackEdit)));
            }

            if (this.userService.hasUserRight(SecurityRight.SaleTabsNotesView))
            {
                fieldGroupTabs.push(new TabModel("Delivery", saleDetails.delivery, this.getFieldGroupsV3(saleDetails, "Delivery"), makeDirty, "delivery", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), this.userService.hasUserRight(SecurityRight.SaleTabsNotesEdit)));

                fieldGroupTabs.push(new TabModel("Notes", saleDetails.notes, this.getFieldGroupsV3(saleDetails, "Notes"), makeDirty, "notes", "", this.userService.hasUserRight(SecurityRight.SaleTabsNotesView), this.userService.hasUserRight(SecurityRight.SaleTabsNotesEdit)));
            }
            if (this.userService.hasUserRight(SecurityRight.SaleTabsCustomView))
            {
                fieldGroupTabs.push(new TabModel("Custom", saleDetails.customFields, this.getFieldGroupsV3(saleDetails, "Custom"), makeDirty, "custom", "", this.userService.hasUserRight(SecurityRight.SaleTabsCustomView), this.userService.hasUserRight(SecurityRight.SaleTabsCustomEdit)));
            }
        }

		// console.log("fieldGroupTabs", fieldGroupTabs);
		return fieldGroupTabs;
	}

	public setupFieldGroupsQuoteV2(saleDetails: SaleDetailsModel, isExpress: boolean, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
	{
		var fieldGroupTabs: TabModel[] = [];
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView) && saleDetails && !editActive && !isExpress)
		{
            var summaryFieldGroups = this.getFieldGroupsV3(saleDetails, "Summary", null, true);
            fieldGroupTabs.push(new TabModel("Summary", saleDetails, summaryFieldGroups, makeDirty, "summary", "", this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView), false));
        }

        if (this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView))
        {
            fieldGroupTabs.push(new TabModel("General", saleDetails.general, this.getFieldGroupsV3(saleDetails, "General", null, true), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralEdit)));
        }
        
        if (this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceView))
        {
            fieldGroupTabs.push(new TabModel("Finance", saleDetails.payments, this.getFieldGroupsV3(saleDetails, "Financials", null, true), makeDirty, "financials", "", this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceView), this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceEdit)));
        }
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView) && !editActive)
        {
            fieldGroupTabs.push(new TabModel("Extras", saleDetails.extras, this.getFieldGroupsV3(saleDetails, "Extras", null, true), makeDirty, "extras", "", this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsQuoteGeneralEdit)));
        }
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceView))
        {
            fieldGroupTabs.push(new TabModel("Notes", saleDetails.notes, this.getFieldGroupsV3(saleDetails, "Notes", null, true), makeDirty, "notes", "", this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceView), this.userService.hasUserRight(SecurityRight.OpportTabsQuoteFinanceEdit)));
        }
		return fieldGroupTabs;
	}

    public setupFieldGroupsFinanceApp(saleDetails: SaleDetailsModel, isExpress: boolean, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
	{
		var fieldGroupTabs: TabModel[] = [];
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView) && saleDetails && !editActive && !isExpress)
		{
            var summaryFieldGroups = this.getFieldGroupsV3(saleDetails, "Summary", null, true);
            fieldGroupTabs.push(new TabModel("Summary", saleDetails, summaryFieldGroups, makeDirty, "summary", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), false));
        }

        if (this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView))
        {
            fieldGroupTabs.push(new TabModel("General", saleDetails.general, this.getFieldGroupsV3(saleDetails, "General", null, true), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
        }
        
        if (this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceView))
        {
            fieldGroupTabs.push(new TabModel("Finance", saleDetails.payments, this.getFieldGroupsV3(saleDetails, "Financials", null, true), makeDirty, "financials", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceEdit)));
        }
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView) && !editActive)
        {
            fieldGroupTabs.push(new TabModel("Extras", saleDetails.extras, this.getFieldGroupsV3(saleDetails, "Extras", null, true), makeDirty, "extras", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
        }
		
        if (this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceView))
        {
            fieldGroupTabs.push(new TabModel("Notes", saleDetails.notes, this.getFieldGroupsV3(saleDetails, "Notes", null, true), makeDirty, "notes", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppFinanceEdit)));
        }
		return fieldGroupTabs;
	}

	taxStatuses: ListItemModel[];//get full list of tax statuses
	public getFieldGroupsV3(sale: SaleDetailsModel, groupId: string, isExpress: boolean = false, isQuote: boolean = false): FieldGroupModel[]
	{
		this.generalService.getCachedTaxStatuses(false).subscribe(w =>
		{
			this.taxStatuses = w.map(v => new ListItemModel(v.taxStatusEnum.toString(), v.name.toString(), null, null, v));
			//remove Tender, POA, and Auction from sale tax statuses
			this.taxStatuses = this.taxStatuses.filter(x => x.id != "2010" && x.id != "2011" && x.id != "2012");
		});

		var field_groups = [];
		var group: FieldGroupModel;
		switch (groupId)
		{
			case "Summary":
				group = new FieldGroupModel("Summary");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				const summary = sale.summary;
				this.addCurrencyField(group, new FieldModel("Vehicles sold", summary.summarySaleVehiclesSoldAmount, "currency"), "toppadding" + (sale.writeback.summarySaleWritebackAmount > 0 ? " haswriteback" : ""));
				this.addCurrencyField(group, new FieldModel("Registration", summary.summaryVehicleRegistrationAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Vehicle insurance", summary.summaryVehicleInsuranceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("MBI/Warranty", summary.summaryBreakdownInsuranceAmount, "currency"));
				// this.addCurrencyField(group, new FieldModel("Service plan", summary.summaryVehicleServicePlanAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("LPI/PPI & GAP cover", (summary.summaryPaymentInsuranceAmount + summary.summaryEquityInsuranceAmount), "currency"));
				this.addCurrencyField(group, new FieldModel("Sale extras", summary.summaryProductAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Subtotal", summary.summarySaleSubTotalAmount, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Less Net Trade(s)", summary.summarySaleNetTradeInsAmount, "currency"), (sale.writeback.summaryPurchaseWritebackAmount > 0 ? " haswriteback" : ""));
				this.addCurrencyField(group, new FieldModel("Net Total", summary.summaryBalanceNetPrice, "currency"), "bold");
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Cash installments", summary.summaryBalanceCashInstallments, "currency"));
				this.addCurrencyField(group, new FieldModel("Amount to finance", summary.summaryFinanceAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Unallocated", summary.summaryBalanceUnallocated, "currency"), "bold " + (summary.summaryBalanceUnallocated > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				group = new FieldGroupModel("");
				group.classes = "nogreyborder";
				group.singleColumn = true;
				this.addCurrencyField(group, new FieldModel("Payments to date", summary.salePaymentsTotalAmount, "currency"));
				this.addCurrencyField(group, new FieldModel("Money outstanding", summary.summaryFinanceOutstandingAmount, "currency"), "bold nounderline " + (summary.summaryFinanceOutstandingAmount > 0 ? "red icoerror" : ""));
				field_groups.push(group);

				if (sale.summary.financeSummary && sale.summary.financeSummary.total)
				{
					group = new FieldGroupModel("Finance summary");
					group.singleColumn = true;
					group.classes = "";
					var totalX = new FieldModel(sale.summary.financeSummary.company ? sale.summary.financeSummary.company : "Total", sale.summary.financeSummary.total, "currency");
					totalX.sublabel = sale.summary.financeSummary.termCaption;
					this.addCurrencyField(group, totalX, "underline");
					field_groups.push(group);
					group = new FieldGroupModel("");
					group.classes = "";
					group.singleColumn = true;
					this.addCurrencyField(group, new FieldModel("Interest", sale.summary.financeSummary.interest, "currency"), "");
					this.addCurrencyField(group, new FieldModel("Cost of Finance", sale.summary.financeSummary.cost, "currency"), "underline");
					field_groups.push(group);
					group = new FieldGroupModel("");
					group.singleColumn = true;
					this.addCurrencyField(group, new FieldModel("Monthly", sale.summary.financeSummary.repaymentMonthly, "currency"), "bold nounderline");
					this.addCurrencyField(group, new FieldModel("Fortnightly", sale.summary.financeSummary.repaymentFortnightly, "currency"), "");
					this.addCurrencyField(group, new FieldModel("Weekly", sale.summary.financeSummary.repaymentWeekly, "currency"), "");
					this.addCurrencyField(group, new FieldModel("Week (48)", sale.summary.financeSummary.repaymentWeek48, "currency"), "");
					field_groups.push(group);
					group = new FieldGroupModel("");
					group.singleColumn = true;
					field_groups.push(group);
				}
				break;


			case "General":
				group = new FieldGroupModel("General");
                if (!isQuote)
                {
                    group.addField(new FieldModel("Sale No.", sale.saleNo, "text", "saleNo", false, false));
                    if (this.userService.mcMinVersion("3.2.23") && !this.editActive)
                    {
                        var saleNoButton = new FieldModel('Change sale no', '', 'button', 'saleNumberChange', false, false, null, "button-sale-number");
                        saleNoButton.buttonExpand = 'block';
                        saleNoButton.buttonSize = 'small';
                        group.addField(saleNoButton);
                    }
                }
				group.addField(new FieldModel(isQuote ? "Date " : "Date of Sale ", sale.general.saleDate, "date", "saleDate", true, false));
				// group.addField(new FieldModel("Sale Status", sale.status.saleStatusEnum, "lookup", "saleStatusEnum", false, null, sale.status.saleStatus));
				group.addField(new FieldModel("Dealership", sale.general.dealershipId, "contact", "dealershipId", true, false, sale.general.dealership));
				group.addField(new FieldModel("Salesperson", sale.general.salesPersonId, "contact", "salesPersonId", true, false, sale.general.salesPerson));
				group.addField(new FieldModel("Business Manager", sale.general.busManagerId, "contact", "busManagerId", true, false, sale.general.busManager));
				if (!isQuote)
                {
                    group.addField(new FieldModel("Invoice Date", sale.general.accDate, "date", "accDate", true, false));
                    group.addField(new FieldModel("Reference", sale.general.reference, "text", "reference", true, false));
                }
				group.addField(new FieldModel("Referrer", sale.general.referralMethodId, "lookup", "referralMethodId", true, false, sale.general.referralMethod));
				group.addField(new FieldModel("Campaign", sale.general.campaignId, "lookup", "campaignId", true, false, sale.general.campaign));

				field_groups.push(group);
				break;

			case "Status":
				group = new FieldGroupModel("Status");
                if (!isExpress)
                {
				    group.addField(new FieldModel("Sale Status", sale.status.saleStatusEnum, "lookup", "saleStatusEnum", true, true, sale.status.saleStatus));
                }
                group.addField(new FieldModel("Sale Type", sale.status.saleTypeEnum, "lookup", "saleTypeEnum", true, true, sale.status.saleType));
				field_groups.push(group);
				break;
			case "Customers":
				group = new FieldGroupModel("Customer" + (sale.general.customers.length > 1 ? "s" : ""));
				sale.general.customers.forEach(function (customer)
				{
					// console.log(customer);
					// group = new FieldGroupModel("Customer ");
					group.addField(new FieldModel("Name", customer.customer.id, "contact", "contactId", false, false, customer.customer));

				});
				field_groups.push(group);

				break;


			// case "Sold Vehicles":
			// 	group = new FieldGroupModel("Vehicles Sold");
			// 	sale.vehiclesSold.forEach(function (vehicle)
			// 	{
			// 		group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
			// 	});
			// 	for (var i = 0; i < (10 - sale.vehiclesSold.length); i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;

			// case "Trade Ins":
			// 	group = new FieldGroupModel("Vehicles Purchased");
			// 	group.singleColumn = true;
			// 	sale.vehiclesPurchased.forEach(function (vehicle)
			// 	{
			// 		group.addField(new FieldModel("Vehicle", vehicle.vehicleId, "vehicle", "vehicleId", false, false, vehicle));
			// 	});
			// 	for (var i = 0; i < (10 - sale.vehiclesPurchased.length); i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;
			// case "Finance Central":
			// 	group = new FieldGroupModel("Finance Central");

			// 	group.addField(new FieldModel("Reference", sale.financeCentralSummary.reference, "text"));
			// 	group.addField(new FieldModel("Status", sale.financeCentralSummary.status, "text"));
			// 	if (sale.financeCentralSummary.total)
			// 	{

			// 		group.addField(new FieldModel("Total Financed", sale.financeCentralSummary.total, "currency", null, false, false, null, " dollar zeros"));
			// 	}
			// 	if (sale.financeCentralSummary.repayments)
			// 	{
			// 		group.addField(new FieldModel("Repayments", sale.financeCentralSummary.repayments, "text"));
			// 	}
			// 	if (sale.financeCentralSummary.link)
			// 	{
			// 		var label = (sale.financeCentralSummary.link.includes("financecentral.co.nz") ? "View in Finance Central" : "View application");

			// 		group.addField(new FieldModel("Finance Application", label, "url", "financeurl", false, false, sale.financeCentralSummary.link));
			// 	}
			// 	for (var i = 0; i < 6; i++)
			// 	{
			// 		group.addField(new FieldModel(" ", " ", "text"));
			// 	}
			// 	field_groups.push(group);
			// 	break;
			case "Delivery":
				group = new FieldGroupModel("Delivery details");
				group.addField(new FieldModel("Delivery status", sale.delivery.deliveryStatusEnum, "lookup", "deliveryStatusEnum", true, false, sale.delivery.deliveryStatus));
				group.addField(new FieldModel("Delivery by", sale.delivery.deliveryStartById, "contact", "deliveryStartById", true, false, sale.delivery.deliveryStartBy));
				group.addField(new FieldModel("Delivery Date & Time", sale.delivery.deliveryEndDate, "datetime", "deliveryEndDate", true, false));
				group.addField(new FieldModel("Delivery Instructions", sale.delivery.deliveryInstructions, "longtext", "deliveryInstructions", true, false, sale.delivery.deliveryInstructions));
				field_groups.push(group);

				if (!this.editActive)
				{
					group = new FieldGroupModel("Delivery checklist");
					group.addField(new FieldModel("Checklist", sale.delivery.deliveryItemIds, "lookups", "deliveryItemIds", false, false, sale.delivery.deliveryItems, '', VehicleClass.None));
					group.addField(new FieldModel("Checked by", sale.delivery.deliveryEndBy, "contact", "deliveryEndByReference", false, null, sale.delivery.deliveryEndBy));
					group.addField(new FieldModel("Checked date", sale.delivery.deliveryEndDate, "datetime", "delEndDate", false, null, sale.delivery.deliveryEndDate));
					field_groups.push(group);
				}
				break;
			case "Checklist":
				group = new FieldGroupModel("Delivery checklist");
				var checklistField = new FieldModel("Checklist", sale.delivery.deliveryItemIds, "lookups", "deliveryItemIds", true, false, sale.delivery.deliveryItems, '', VehicleClass.None)
				group.addField(checklistField);
				field_groups.push(group);
				break;
			case "Notes":
                if (!isQuote)
                {
                    group = new FieldGroupModel("Special conditions");
                    if (this.userService.mcMinVersion("3.2.23") && this.editActive)
                    {
                        group.editLink = true;
                    }
                    group.addField(new FieldModel("Special conditions", sale.notes.specialConditions, "longtext", "specialConditions", true, false, sale.notes.specialConditions));
                    field_groups.push(group);
                }

                group = new FieldGroupModel("Notes");
                group.addField(new FieldModel("Internal notes", sale.notes.internalNotes, "longtext", "internalNotes", true, false, sale.notes.internalNotes));
				if (!isQuote)
                {
                    group.addField(new FieldModel("Uninvited direct sale", sale.notes.uninvitedDirectSale, "toggle", "uninvitedDirectSale", true, false));
                }
                field_groups.push(group);
				break;
			case "Extras":
				group = new FieldGroupModel("");
				sale.extras.saleProducts.forEach(function (extra)
				{
					if (extra.productClass == ProductClass.General)
					{
						var field = new FieldModel("Extras", extra.saleAmount, "currency", "extras", false, false);
						field.label = extra.description;
						group.addField(field);
					}
				});

				field_groups.push(group);
				break;
			case "Payments":
				group = new FieldGroupModel("");
				sale.payments.salePayments.forEach(function (payment)
				{
					var field = new FieldModel("Payments", payment.paymentAmount, "currency", "payments", false, false);
					var paymentDate = new Date(payment.paymentDate);
					field.label = DateHelper.getDateTimeAsFormat(paymentDate, Constants.DateFormatShort);
					group.addField(field);
				});
				field_groups.push(group);
				break
			case "Insurance":
				group = new FieldGroupModel("Insurance");
				if (!this.editActive)
				{
					group.addField(new FieldModel("Insurance type", sale.insurance.insDealer ? "Purchaser has requested the dealership to arrange cover at their expense" : "Purchaser will arrange own insurance as from delivery", "text", "insuranceType", false, false));
				}
				else
				{
					group.addField(new FieldModel("Sale includes insurance", sale.insurance.insDealer, "toggle", "insDealer", true, false));
				}
				group.addField(new FieldModel("Insurer", sale.insurance.insCompanyId, "contact", "insCompanyId", true, false, sale.insurance.insCompany));
				group.addField(new FieldModel("Branch", sale.insurance.insBranch, "text", "insBranch", true, false));
				group.addField(new FieldModel("Policy number", sale.insurance.insPolicyDesc, "text", "insPolicyDesc", true, false));
				group.addField(new FieldModel("Cover value", sale.insurance.insCoverDesc, "currency", "insCoverDesc", true, false));
				group.addField(new FieldModel("Expiry date", sale.insurance.insExpiryDate, "date", "insExpiryDate", true, false));
				field_groups.push(group);
				break;
			case "Financials":

                if (isQuote)
                {
                    group = new FieldGroupModel("Trade-ins");
                    group.singleColumn = true;
                    group.addField(new FieldModel("Value of trade-ins", sale.payments.payment3Amount, "currency", "payment3Amount", true, false));
                    group.addField(new FieldModel("Encumbrance", sale.payments.payment4Amount, "currency", "payment4Amount", true, false));
                    field_groups.push(group);
                }

				group = new FieldGroupModel("Cash Installments");
				var depositOnSigning = new FieldModel("Deposit on signing", sale.payments.payment1Amount, "currency", "payment1Amount", true, false);
				group.addField(depositOnSigning);

				var dueOnDelivery = new FieldModel("Due on delivery", sale.payments.payment2Amount, "currency", "payment2Amount", true, false);
				group.addField(dueOnDelivery);

                if (!isQuote)
                {
                    var additionalPayments = new FieldModel("Additional payments", sale.payments.payment3Amount, "currency", "payment3Amount", true, false);
                    group.addField(additionalPayments);

                    group.addField(new FieldModel("Settlement date", sale.payments.settleDate, "date", "settleDate", true, false));
                }
                field_groups.push(group);
				group = new FieldGroupModel("Finance Information");

				group.addField(new FieldModel("Financier", sale.payments.finCompanyId, "contact", "finCompanyId", true, false, sale.payments.finCompany));
				group.addField(new FieldModel("Term Count", sale.payments.finTermCount, "number", "finTermCount", true, false));
				group.addField(new FieldModel("Term period", sale.payments.finTermPeriodId, "lookup", "finTermPeriodId", true, false, sale.payments.finTermPeriod));
				group.addField(new FieldModel("Term rate", sale.payments.finTermRate, "text", "finTermRate", true, false));

				var financeAmount = new FieldModel("Amount to finance", sale.payments.summaryFinanceAmount, "currency", "summaryFinanceAmount", true, false);
				group.addField(financeAmount);

				var establishmentFeeObject = new PriceEditorModel();
				establishmentFeeObject.removeTaxTypes = true;
				establishmentFeeObject.price = { id: "costEstFee", value: sale.payments.costEstFee };
				establishmentFeeObject.taxType = { id: "costEstTaxStatusEnum", value: sale.payments.costEstTaxStatusEnum };
				establishmentFeeObject.mode = "extended";
				establishmentFeeObject.currency = { id: "costEstCurrencyId", value: "" };
				establishmentFeeObject.taxRate = { id: "costEstTaxRate", value: sale.payments.costEstTaxRate };
				establishmentFeeObject.taxAmount = { id: "costEstTaxAmount", value: sale.payments.costEstTaxAmount };
				group.addField(new FieldModel("Establishment fees", sale.payments.costEstFee, "price", "costEstFee", true, false, establishmentFeeObject));

				var referralFeeObject = new PriceEditorModel();
				referralFeeObject.removeTaxTypes = true;
				referralFeeObject.price = { id: "costReferralFee", value: sale.payments.costReferralFee };
				referralFeeObject.taxType = { id: "costReferralTaxStatusEnum", value: sale.payments.costReferralTaxStatusEnum };
				referralFeeObject.mode = "extended";
				referralFeeObject.currency = { id: "costReferralCurrencyId", value: "" };
				referralFeeObject.taxRate = { id: "costReferralTaxRate", value: sale.payments.costReferralTaxRate };
				referralFeeObject.taxAmount = { id: "costReferralTaxAmount", value: sale.payments.costReferralTaxAmount };
				group.addField(new FieldModel("Referral fees", sale.payments.costReferralFee, "price", "costReferralFee", true, false, referralFeeObject));

				field_groups.push(group);

				break;
			case "Writeback":
				group = new FieldGroupModel("Sold Vehicles");

				sale.writeback.vehiclesSoldWriteback.forEach(function (soldVehicle)
				{
					var writebackObject = new PriceEditorModel();
					writebackObject.removeTaxTypes = true;
					writebackObject.id = soldVehicle.saleVehicleId;
					writebackObject.price = { id: "writebackAmount", value: soldVehicle.writebackAmount };
					writebackObject.taxType = { id: "writebackTaxStatusEnum", value: soldVehicle.writebackTaxStatusEnum };
					var label = "#" + soldVehicle.vehicle.stockNo.toString() + " - " + soldVehicle.vehicle.yearManuModelCaption;
					writebackObject.mode = "extended";
					writebackObject.currency = { id: "writebackCurrencyId", value: "" };
					writebackObject.taxRate = { id: "writebackTaxRate", value: soldVehicle.writebackTaxRate };
					writebackObject.taxAmount = { id: "writebackTaxAmount", value: soldVehicle.writebackTaxAmount };
					group.addField(new FieldModel(label, soldVehicle.writebackAmount, "price", "writebackAmount", true, false, writebackObject));
				});



				if (!this.editActive)
				{
					var writebackTotalObject = new PriceEditorModel();
					writebackTotalObject.removeTaxTypes = true;
					writebackTotalObject.price = { id: "writebackTotal", value: sale.writeback.summarySaleWritebackAmount };
					writebackTotalObject.taxType = { id: "writebackTaxStatusEnum", value: 1010 };
					// writebackTotalObject.mode = "extended";
					// writebackTotalObject.currency = {id: "writebackCurrencyId", value: ""};
					// writebackTotalObject.taxRate = {id: "writebackTaxRate", value: sale.writeback.summarySaleWritebackTaxRate};
					// writebackTotalObject.taxAmount = {id: "writebackTaxAmount", value: sale.writeback.summarySaleWritebackTaxAmount};
					group.addField(new FieldModel("Total", sale.writeback.summarySaleWritebackAmount, "price", "writebackTotal", false, false, writebackTotalObject));
				}

				group.singleColumn = true;

				field_groups.push(group);

				group = new FieldGroupModel("Trade-in Vehicles");

				sale.writeback.vehiclesPurchasedWriteback.forEach(function (purchasedVehicle)
				{

					var writebackObject = new PriceEditorModel();
					writebackObject.removeTaxTypes = true;
					writebackObject.id = purchasedVehicle.saleVehicleId;
					writebackObject.price = { id: "writebackAmount", value: purchasedVehicle.writebackAmount };
					writebackObject.taxType = { id: "writebackTaxStatusEnum", value: purchasedVehicle.writebackTaxStatusEnum };
					var label = "#" + purchasedVehicle.vehicle.stockNo.toString() + " - " + purchasedVehicle.vehicle.yearManuModelCaption;
					writebackObject.mode = "extended";
					writebackObject.currency = { id: "writebackCurrencyId", value: "" };
					writebackObject.taxRate = { id: "writebackTaxRate", value: purchasedVehicle.writebackTaxRate };
					writebackObject.taxAmount = { id: "writebackTaxAmount", value: purchasedVehicle.writebackTaxAmount };
					group.addField(new FieldModel(label, purchasedVehicle.writebackAmount, "price", "writebackAmount", true, false, writebackObject));
				});

				if (!this.editActive)
				{
					var writebackTotalObject = new PriceEditorModel();
					writebackTotalObject.removeTaxTypes = true;
					writebackTotalObject.price = { id: "writebackTotal", value: sale.writeback.summaryPurchaseWritebackAmount };
					writebackTotalObject.taxType = { id: "writebackTaxStatusEnum", value: 1010 };
					// writebackTotalObject.mode = "extended";
					// writebackTotalObject.currency = {id: "writebackCurrencyId", value: ""};
					// writebackTotalObject.taxRate = {id: "writebackTaxRate", value: sale.writeback.summaryPurchaseWritebackTaxRate};
					// writebackTotalObject.taxAmount = {id: "writebackTaxAmount", value: sale.writeback.summaryPurchaseWritebackTaxAmount};
					group.addField(new FieldModel("Total", sale.writeback.summaryPurchaseWritebackAmount, "price", "writebackTotal", false, false, writebackTotalObject));
				}

				group.singleColumn = true;

				field_groups.push(group);

				if (!this.editActive && sale.writeback.summaryWritebackBalanceAmount != 0)
				{
					group = new FieldGroupModel(" ");
					this.addCurrencyField(group, new FieldModel("Unallocated amount", sale.writeback.summaryWritebackBalanceAmount, "currency"), "bold nounderline " + (sale.writeback.summaryWritebackBalanceAmount != 0 ? "red icoerror" : ""));
					group.singleColumn = true;
					field_groups.push(group);
				}

				break;
			case "Custom":
				group = new FieldGroupModel("Custom Fields");
				group.singleColumn = true;
				for (let i = 1; i <= 12; i++) 
				{
					const customFieldDisplayModel = CustomFieldDisplayModel.fromDto(sale.customFields[`customField${i}_Object`]);
					if (customFieldDisplayModel.visible)
					{
						const customFieldValue = sale.customFields[`customField${i}`];
						group.addField(new FieldModel(customFieldDisplayModel.name, customFieldValue, customFieldDisplayModel.fieldModelType, `customField${i}`, true, false, customFieldDisplayModel.dropdownOptions));
					}
				}
				field_groups.push(group);
				break;

		}
		return field_groups;
	}

	public uploadDocuments(vehicleId: string, files: Blob[], title: string, documentCategory: string, uploadDocumentName: string[]): Observable<any>
	{
		let url = Constants.ApiUrl + 'sales/' + vehicleId + '/document/new';

		const formData = new FormData();
		for (var i = 0; i < files.length; i++)
		{
			formData.append('document', files[i]);
			formData.append('title', title);
			formData.append('documentCategory', documentCategory);
			formData.append('uploadDocumentName', uploadDocumentName[i]);
		}
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });

	}

	public updateDocument(vehicleId: string, documentUri: string, fileDesc: string, fileCategory: number): Observable<SingleDocumentUploadModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);
		httpParams = httpParams.append('fileDesc', fileDesc);
		httpParams = httpParams.append('fileCategory', fileCategory);
		return this.httpClient.patch<SingleDocumentUploadModel>(Constants.ApiUrl + 'sales/' + vehicleId + '/document/update', httpParams);
	}

	public deleteDocument(vehicleId: string, documentUri: string): Observable<Array<DocumentModel>>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);

		return this.httpClient.delete<Array<DocumentModel>>(Constants.ApiUrl + 'sales/' + vehicleId + '/document/delete', { params: httpParams });
	}

	public updateSaleCustomers(saleId: string, saleGeneral: SaleDetails_General): Observable<any>
	{
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'sales/' + saleId + '/general', saleGeneral);
	}

	public updateSaleVehicles(saleId: string, saleVehicles: SaleDetails_Vehicles): Observable<any>
	{
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles', saleVehicles);
	}

	public updateSaleTradeInVehicles(saleId: string, saleTradeInVehicleIds: string[]): Observable<any>
	{
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles/appraisals', saleTradeInVehicleIds);
	}

	public saveSale(sale: SaleDetailsModel): Observable<SaleDetailsModel>
	{
		return this.httpClient.put<SaleDetailsModel>(Constants.ApiUrl + 'sales/' + sale.saleId, sale);
	}


	public setupExtrasFields(saleDetails: SaleDetailsModel): any[]
	{
		let field_groups = [];
		let group = new FieldGroupModel("");

		if (saleDetails.extras && saleDetails.extras.saleProducts.length > 0)
		{
			for (let extra of saleDetails.extras.saleProducts)
			{
				if (extra.productClass == ProductClass.General)
				{
					var extraDetails = new FieldModel(extra.caption, extra.saleAmount ? extra.saleAmount : 0, "currency");
					extraDetails.id = extra.productId;
					extraDetails.sublabel = extra.reference || " ";
					extraDetails.subvalue = "Quantity: " + extra.partQty;
					extraDetails.detailObject = extra;
					extraDetails.detailObject.type = "extra";
					extraDetails.classes = 'vehicle-activity-list-item';
					extraDetails.detail = true;
					group.addField(extraDetails);
				}

			}
		}

		group.singleColumn = true;
		field_groups.push(group);

		return field_groups;
	}


	public setupPaymentsFields(saleDetails: SaleDetailsModel): any[]
	{
		let field_groups = [];
		let group = new FieldGroupModel("");

		if (saleDetails.payments && saleDetails.payments.salePayments.length > 0)
		{
			for (let payment of saleDetails.payments.salePayments)
			{

				//create date from payment date
				var paymentDate = new Date(payment.paymentDate);

				//create a variable of payment amount as a currency
				var paymentDetails = new FieldModel(paymentDate.toDateString(), payment.paymentAmount.toString(), "currency");
				paymentDetails.id = payment.salePaymentId;
				paymentDetails.sublabel = payment.reference || '-';
				paymentDetails.subvalue = payment.comment || '-';
				paymentDetails.detailObject = payment;
				paymentDetails.detailObject.type = "payment";
				paymentDetails.classes = 'vehicle-activity-list-item';
				paymentDetails.detail = true;
				group.addField(paymentDetails);
			}
		}

		group.singleColumn = true;
		field_groups.push(group);

		return field_groups;
	}

	public setupEquityInsurance(saleDetails: SaleDetailsModel): any[]
	{

		let field_groups = [];
		let group = new FieldGroupModel("GAP Cover");

		if (saleDetails.extras && saleDetails.extras.saleProducts.length > 0)
		{
			for (let extra of saleDetails.extras.saleProducts)
			{
				if (extra.productClass == ProductClass.EquityInsurance)
				{
					var extraDetails = new FieldModel(extra.caption, extra.saleAmount ? extra.saleAmount : 0, "currency");
					extraDetails.id = extra.productId;
					extraDetails.sublabel = extra.reference || " ";
					extraDetails.subvalue = "";
					extraDetails.detailObject = extra;
					extraDetails.detailObject.type = "extra";
					extraDetails.classes = 'vehicle-activity-list-item';
					extraDetails.detail = true;
					group.addField(extraDetails);
				}

			}
		}

		if (group.fields.length == 0)
		{
			group.addField(new FieldModel("-", "-", "text", "noEquityInsurance", true, false));
		}

		group.singleColumn = true;
		field_groups.push(group);
		return field_groups;
	}

	public setupPaymentInsurance(saleDetails: SaleDetailsModel): any[]
	{
		let field_groups = [];
		let group = new FieldGroupModel("LPI/PPI");

		if (saleDetails.extras && saleDetails.extras.saleProducts.length > 0)
		{
			for (let extra of saleDetails.extras.saleProducts)
			{
				if (extra.productClass == ProductClass.PaymentInsurance)
				{
					var extraDetails = new FieldModel(extra.caption, extra.saleAmount ? extra.saleAmount : 0, "currency");
					extraDetails.id = extra.productId;
					extraDetails.sublabel = extra.reference || " ";
					extraDetails.subvalue = "";
					extraDetails.detailObject = extra;
					extraDetails.detailObject.type = "extra";
					extraDetails.classes = 'vehicle-activity-list-item';
					extraDetails.detail = true;
					group.addField(extraDetails);
				}

			}
		}

		if (group.fields.length == 0)
		{
			group.addField(new FieldModel("-", "-", "text", "noPaymentInsurance", true, false));
		}

		group.singleColumn = true;
		field_groups.push(group);
		return field_groups;
	}

	public GetProductsByProductClass(productClass: ProductClass): Observable<SaleDetails_SaleProduct[]>
	{
		let httpParams = new HttpParams();

		httpParams = httpParams.append('productClass', productClass);

		return this.httpClient.get<SaleDetails_SaleProduct[]>(Constants.ApiUrl + 'sales/products', { params: httpParams });
	}

	public CalculateSummary(salePayments: SaleDetails_Payments): Observable<SaleDetailsModel>
	{
		return this.httpClient.post<SaleDetailsModel>(Constants.ApiUrl + 'sales/calculate', salePayments);
	}

	public GetSummary(saleId: string, includeGST: boolean = true): Observable<SaleDetails_Summary>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('includeGST', includeGST);

		return this.httpClient.get<SaleDetails_Summary>(Constants.ApiUrl + 'sales/' + saleId + '/summary', { params: httpParams });
	}

	public getSaleVehicleTemplate(saleId: string, vehicleId: string, vehicleType: SaleVehicleType): Observable<SaleDetails_Vehicle>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('vehicleId', vehicleId);
		httpParams = httpParams.append('vehicleType', vehicleType);

		return this.httpClient.get<SaleDetails_Vehicle>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles/new', { params: httpParams });
	}

	public createSaleVehicle(saleId: string, saleVehicle: SaleDetails_Vehicle): Observable<SaleDetails_Vehicle>
	{
		return this.httpClient.post<SaleDetails_Vehicle>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles/new', saleVehicle);
	}

	public updateSaleVehicle(saleId: string, saleVehicle: SaleDetails_Vehicle): Observable<SaleDetails_Vehicle>
	{
		return this.httpClient.patch<SaleDetails_Vehicle>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles/' + saleVehicle.vehicleId, saleVehicle);
	}

	public removeSaleVehicle(saleId: string, vehicleId: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('vehicleId', vehicleId);

		return this.httpClient.delete<string>(Constants.ApiUrl + 'sales/' + saleId + '/vehicles/' + vehicleId, { params: httpParams });
	}

	public getSaleCustomerTemplate(saleId: string, customerId: string): Observable<SaleDetails_Customer>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('customerId', customerId);

		return this.httpClient.get<SaleDetails_Customer>(Constants.ApiUrl + 'sales/' + saleId + '/customers/new', { params: httpParams });
	}

	public createSaleCustomer(saleId: string, saleCustomer: SaleDetails_Customer): Observable<SaleDetails_Customer>
	{
		return this.httpClient.post<SaleDetails_Customer>(Constants.ApiUrl + 'sales/' + saleId + '/customers/new', saleCustomer);
	}

	public removeSaleCustomer(saleId: string, customerId: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('customerId', customerId);

		return this.httpClient.delete<string>(Constants.ApiUrl + 'sales/' + saleId + '/customers/' + customerId, { params: httpParams });
	}

	public replaceSaleCustomer(saleId: string, oldCustomerId: string, newCustomerId: string): Observable<SaleDetails_Customer>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('oldCustomerId', oldCustomerId);
		httpParams = httpParams.append('newCustomerId', newCustomerId);

		return this.httpClient.patch<SaleDetails_Customer>(Constants.ApiUrl + 'sales/' + saleId + '/customers/replace', httpParams);
	}

	public makeSaleCustomerPrimary(saleId: string, customerId: string): Observable<SaleDetails_Customer>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('customerId', customerId);

		return this.httpClient.patch<SaleDetails_Customer>(Constants.ApiUrl + 'sales/' + saleId + '/customers/primary', httpParams);
	}

	public getSaleExtraTemplate(saleId: string): Observable<SaleDetails_SaleProduct>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);

		return this.httpClient.get<SaleDetails_SaleProduct>(Constants.ApiUrl + 'sales/' + saleId + '/extras/new', { params: httpParams });
	}

	public createSaleExtra(saleId: string, saleExtra: SaleDetails_SaleProduct): Observable<SaleDetails_SaleProduct>
	{
		return this.httpClient.post<SaleDetails_SaleProduct>(Constants.ApiUrl + 'sales/' + saleId + '/extras/new', saleExtra);
	}

    public createSaleExtras(saleId: string, saleExtras: SaleDetails_SaleProduct[]): Observable<SaleDetails_SaleProduct[]>
	{
		return this.httpClient.post<SaleDetails_SaleProduct[]>(Constants.ApiUrl + 'sales/' + saleId + '/extras/newMulti', saleExtras);
	}


	public updateSaleExtra(saleId: string, productId: string, saleExtra: SaleDetails_SaleProduct): Observable<SaleDetails_SaleProduct>
	{
		return this.httpClient.patch<SaleDetails_SaleProduct>(Constants.ApiUrl + 'sales/' + saleId + '/extras/' + productId, saleExtra);
	}

	public removeSaleExtra(saleId: string, productId: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('productId', productId);

		return this.httpClient.delete<string>(Constants.ApiUrl + 'sales/' + saleId + '/extras/' + productId, { params: httpParams });
	}

	public getSalePaymentTemplate(saleId: string): Observable<SaleDetails_Payment>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);

		return this.httpClient.get<SaleDetails_Payment>(Constants.ApiUrl + 'sales/' + saleId + '/payments/new', { params: httpParams });
	}

	public createSalePayment(saleId: string, salePayment: SaleDetails_Payment): Observable<SaleDetails_Payment>
	{
		return this.httpClient.post<SaleDetails_Payment>(Constants.ApiUrl + 'sales/' + saleId + '/payments/new', salePayment);
	}

	public updateSalePayment(saleId: string, paymentId: string, salePayment: SaleDetails_Payment): Observable<SaleDetails_Payment>
	{
		return this.httpClient.patch<SaleDetails_Payment>(Constants.ApiUrl + 'sales/' + saleId + '/payments/' + paymentId, salePayment);
	}

	public removeSalePayment(saleId: string, paymentId: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('paymentId', paymentId);

		return this.httpClient.delete<string>(Constants.ApiUrl + 'sales/' + saleId + '/payments/' + paymentId, { params: httpParams });
	}

	public getNewSaleTemplate(): Observable<SaleDetailsModel>
	{
		return this.httpClient.get<SaleDetailsModel>(Constants.ApiUrl + 'sales/new');
	}

	public createSaleForCustomer(sale: SaleDetailsModel, customerId: string): Observable<SaleDetailsModel>
	{
		return this.httpClient.post<SaleDetailsModel>(Constants.ApiUrl + 'sales/new/' + customerId, sale);
	}

	public emailSalePaymentReceipt(saleId: string, paymentId: string, email: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('paymentId', paymentId);
		httpParams = httpParams.append('email', email);

		return this.httpClient.get<string>(Constants.ApiUrl + 'sales/' + saleId + '/payments/' + paymentId + '/email', { params: httpParams });
	}

	public getSalePaymentPdf(saleId: string, paymentId: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('paymentId', paymentId);

		return this.httpClient.get(Constants.ApiUrl + 'Sales/' + saleId + '/payments/' + paymentId + "/pdf", { params: httpParams, responseType: "blob" });
	}

	public getSalePaymentPdfUrl(saleId: string, paymentId: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('paymentId', paymentId);

		return this.httpClient.get<string>(Constants.ApiUrl + 'Sales/' + saleId + '/payments/' + paymentId + "/pdf/url", { params: httpParams });
	}

	submitToFinanceProvider(saleId: string, dealerLed: boolean): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('saleId', saleId);
		httpParams = httpParams.set('dealerLed', dealerLed ? "true" : "false");
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleId + '/submitToFinanceProvider', httpParams);
	}

	withdrawFinanceApplication(saleId: string, reason: string): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('saleId', saleId);
		httpParams = httpParams.set('reason', reason);
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleId + '/withdrawFinanceApplication', httpParams);
	}

	updateSaleType(saleId: string, saleType: SaleTypeFilter): Observable<SaleDetailsModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('saleId', saleId);
		httpParams = httpParams.set('saleType', saleType);
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleId + '/type', httpParams);
	}

	removeFinance(saleId: string): Observable<SaleDetailsModel>
	{
		return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleId + '/removeFinance', null);
	}

	getSaleTasks(saleId: string,
		taskTypeId: string = Constants.EmptyGuid, taskStatusId: string = Constants.EmptyGuid, query: string = '',
		startDate: string = Constants.DateMinimum, endDate: string = Constants.DateMaximum, pageNumber: number = 1
	): Observable<TasksSearchResult>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('saleId', saleId);
		httpParams = httpParams.append('taskTypeId', taskTypeId);
		httpParams = httpParams.append('taskStatusId', taskStatusId);
		httpParams = httpParams.append('query', query);
		httpParams = httpParams.append('startDate', startDate);
		httpParams = httpParams.append('endDate', endDate);
		httpParams = httpParams.append('pageNumber', pageNumber.toString());
		return this.httpClient.get<TasksSearchResult>(Constants.ApiUrl + 'Sales/' + saleId + "/Tasks", { params: httpParams });
	}

    deleteSale(saleId: string, reason: string): Observable<boolean>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('saleId', saleId);
        httpParams = httpParams.append('reason', reason);
        return this.httpClient.delete<boolean>(Constants.ApiUrl + 'Sales/' + saleId, { params: httpParams });
    }

    getMoneyOutstandingSales(searchParams: MoneyOutstandingSearchParamsModel): Observable<MoneyOutstandingSearchResult>
	{
		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient.get<MoneyOutstandingSearchResult>(Constants.ApiUrl + 'sales/MoneyOutstanding', { params: httpParams });
	}

    updateSaleNumber(saleId: string, saleNo: number): Observable<SaleDetailsModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('saleNo', saleNo);
        return this.httpClient.patch<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + saleId + '/updateSaleNumber', httpParams);
    }

    getExistingFinanceApp(contactId: string, dealershipId: string): Observable<SaleDetailsModel>
    {
        return this.httpClient.get<SaleDetailsModel>(Constants.ApiUrl + 'Sales/' + contactId + '/existingFinanceApp/' + dealershipId);
    }

    getSaleProducts(searchParams: SaleProductsSearchParamsModel): Observable<SaleProductsSearchResult>
	{
		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient.get<SaleProductsSearchResult>(Constants.ApiUrl + 'Sales/SaleProducts', { params: httpParams });
	}

    getInsuranceProviders(vehicleId: string, saleId: string, productClass: ProductClass): Observable<InsuranceProviderValidationModel>
    {
        return this.httpClient.get<InsuranceProviderValidationModel>(Constants.ApiUrl + 'Insurances/' + saleId + '/Providers/' + vehicleId + '/' + productClass);
    }

    productQualify(saleProduct: SaleDetails_SaleProduct, forceShow: boolean): Observable<InsuranceProviderValidationModel>
    {
        return this.httpClient.post<InsuranceProviderValidationModel>(Constants.ApiUrl + 'Insurances/ProductQualify/' + forceShow, saleProduct);
    }

    productsQualify(saleId: string, saleProductIds: string[]): Observable<InsuranceProviderValidationModel[]>
    {
        return this.httpClient.post<InsuranceProviderValidationModel[]>(Constants.ApiUrl + 'Insurances/ProductsQualify/' + saleId, saleProductIds);
    }

    getInsuranceDynamicValidationParams(insuranceProviderValidation: InsuranceProviderValidationModel): Observable<InsuranceProviderValidationModel>
    {
        return this.httpClient.post<InsuranceProviderValidationModel>(Constants.ApiUrl + 'Insurances/DynamicValidationParams', insuranceProviderValidation);
    }

    submitInsuranceParams(paramPayload: InsuranceProviderValidationModel): Observable<SaleDetails_SaleProduct>
    {
        return this.httpClient.post<SaleDetails_SaleProduct>(Constants.ApiUrl + 'Insurances/SubmitInsuranceParams', paramPayload);
    }

    submitMviParams(paramPayload: InsuranceProviderValidationModel): Observable<SaleDetails_SaleProduct>
    {
        return this.httpClient.post<SaleDetails_SaleProduct>(Constants.ApiUrl + 'Insurances/SubmitMviParams', paramPayload);
    }

    getSaleWorkflowProducts(saleId: string): Observable<SaleDetails_SaleProduct[]>
    {
        return this.httpClient.get<SaleDetails_SaleProduct[]>(Constants.ApiUrl + 'Sales/' + saleId + '/ProductWorkflows');
    }

    getReportUrlForWorkflowProducts(saleId: string, saleProductsIds: string[]): Observable<LabelValueModel>
    {
        return this.httpClient.post<LabelValueModel>(Constants.ApiUrl + 'Sales/' + saleId + '/WorkflowProductsReportUrl', saleProductsIds);
    }

    
    markSaleWorkflowProductStatus(saleId: string, workflowStatus: WorkflowStatus, saleProductsIds: string[]): Observable<SaleDetails_SaleProduct>
    {
        return this.httpClient.post<SaleDetails_SaleProduct>(Constants.ApiUrl + 'Sales/' + saleId + '/MarkWorkflowProductStatus/' + workflowStatus, saleProductsIds);
    }
    
    cancelSaleWorkflowProduct(saleId: string, saleProductsIds: string[], reason: string): Observable<SaleDetails_SaleProduct>
    {
        var httpParams = new HttpParams();
        httpParams = httpParams.set('reason', reason);
        return this.httpClient.post<SaleDetails_SaleProduct>(Constants.ApiUrl + 'Sales/' + saleId + '/CancelWorkflowProduct', saleProductsIds, { params: httpParams });
    }

    validateInsuranceParams(paramPayload: InsuranceProviderValidationModel): Observable<void>
    {
        return this.httpClient.post<void>(Constants.ApiUrl + 'Insurances/ValidateInsuranceParams', paramPayload);
    }

    registerSaleWorkflowProduct(paramPayload: InsuranceProviderValidationModel, workflowAction: WorkflowAction): Observable<ProductQuoteModel>
    {
        return this.httpClient.post<ProductQuoteModel>(Constants.ApiUrl + 'Insurances/RegisterSaleWorkflowProduct/' + workflowAction, paramPayload);
    }

    registerSaleWorkflowSaleProduct(product: SaleDetails_SaleProduct, workflowAction: WorkflowAction): Observable<ProductQuoteModel>
    {
        return this.httpClient.post<ProductQuoteModel>(Constants.ApiUrl + 'Insurances/RegisterSaleWorkflowSaleProduct/' + workflowAction, product);
    }

    registerSaleWorkflowProducts(paramPayload: InsuranceProviderValidationModel[], workflowAction: WorkflowAction): Observable<ProductQuoteModel>
    {
        return this.httpClient.post<ProductQuoteModel>(Constants.ApiUrl + 'Insurances/RegisterSaleWorkflowProducts/' + workflowAction, paramPayload);
    }

    getProviderManuModelVariant(manuModelVariant: InsuranceProviderManuModelVariantModel): Observable<InsuranceProviderManuModelVariantModel>
    {
        return this.httpClient.post<InsuranceProviderManuModelVariantModel>(Constants.ApiUrl + 'Insurances/ProviderManuModelVariant', manuModelVariant);
    }

    public async setupInsuranceFieldGroups(insuranceParams: InsuranceParamModel[], makeDirty: boolean = false): Promise<TabModel[]>
    {

        var fieldGroupTabs: TabModel[] = [];

        if (this.userService.hasUserRight(SecurityRight.Reports))
        {
            fieldGroupTabs.push(new TabModel("General", insuranceParams, await this.getInsuranceFieldGroups(insuranceParams, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.SaleTabsFinanceView), this.userService.hasUserRight(SecurityRight.SaleTabsFinanceEdit)));
        }

        return fieldGroupTabs;
    }
    
    public async getInsuranceFieldGroups(insuranceParams: InsuranceParamModel[], groupId: string, isExpress: boolean = false): Promise<FieldGroupModel[]> {
        var field_groups = [];
        switch (groupId)
        {
            case "General":
                var responsibleLendingCodeTermsConditions = new FieldGroupModel("Responsible Lending Code / Terms & Conditions");
                var customerInformation = new FieldGroupModel("Customer Information");
                var customerDisclosure = new FieldGroupModel("Customer Disclosure");
                var vehicleInformation = new FieldGroupModel("Vehicle Information");
                var financeInsuranceInformation = new FieldGroupModel("Finance & Insurance Information");
                var paymentDetails = new FieldGroupModel("Payment Details");
                var drivers = new FieldGroupModel("Driver(s)");
                var generalQuestions = new FieldGroupModel("General Questions");
                var additionalQuestions = new FieldGroupModel("Additional Questions");

                for (const param of insuranceParams)
                {
                    var field: FieldModel;
                    switch (param.paramType)
                    {
                        case InsuranceParamType.Guid:
                            field = new FieldModel(param.paramLabel, param.paramValue, "contact", param.paramId, true, param.paramIsMandatory, param.paramObject);
                            break;
                        case InsuranceParamType.Select:
                        case InsuranceParamType.Enum:
                            if (Array.isArray(param.paramObject))
                            {
                                var options = [];
                                for (let option of param.paramObject)
                                {
                                    options.push(new ListItemModel(option.id, option.caption));
                                }
                                field = new FieldModel(param.paramLabel, param.paramValue, "select", param.paramId, true, param.paramIsMandatory, options);
                                break;
                            }

                            field = new FieldModel(param.paramLabel, param.paramValue, "select", param.paramId, true, param.paramIsMandatory, param.paramObject);
                            break;
                        case InsuranceParamType.YesNo:
                            var options = [];
                            for (let option of param.paramObject)
                            {
                                options.push(new ListItemModel(option, option));
                            }    
                            field = new FieldModel(param.paramLabel, param.paramValue, "segment", param.paramId, true, param.paramIsMandatory, options);
                            break;
                        case InsuranceParamType.Selects:
                            if (Array.isArray(param.paramObject))
                            {
                                var options = [];
                                for (let option of param.paramObject)
                                {
                                    options.push(new ListItemModel(option.member, option.caption));
                                }
                                field = new FieldModel(param.paramLabel, param.paramValue, "selects", param.paramId, true, param.paramIsMandatory, options);
                                break;
                            }

                            field = new FieldModel(param.paramLabel, param.paramValue, "selects", param.paramId, true, param.paramIsMandatory, param.paramObject);
                            break;
                        case InsuranceParamType.Boolean:
                            field = new FieldModel(param.paramLabel, param.paramValue, "toggle", param.paramId, true, param.paramIsMandatory);
                            break;
                        case InsuranceParamType.String:
                            field = new FieldModel(param.paramLabel, param.paramValue, "text", param.paramId, true, param.paramIsMandatory);
                            break;
                        case InsuranceParamType.Date:
                            field = new FieldModel(param.paramLabel, param.paramValue, "date", param.paramId, true, param.paramIsMandatory);
                            break;
                        case InsuranceParamType.DateRange:
                            field = new FieldModel(param.paramLabel, param.paramValue, "date-picker", param.paramId, true, param.paramIsMandatory, param.paramObject);
                            break;
                        case InsuranceParamType.Integer:
                            field = new FieldModel(param.paramLabel, param.paramValue, "number", param.paramId, true, param.paramIsMandatory);
                            break;
                        case InsuranceParamType.Lookup:
                            field = new FieldModel(param.paramLabel, param.paramValue, "lookup", param.paramId, true, param.paramIsMandatory, param.paramObject);
                            break;
                        case InsuranceParamType.Lookups:
                            field = new FieldModel(param.paramLabel, param.paramValue, "lookups", param.paramId, true, param.paramIsMandatory, param.paramObject, null, VehicleClass.All);
                            break;
                        case InsuranceParamType.LongText:
                            field = new FieldModel(param.paramLabel, param.paramValue, "longtext", param.paramId, false, false, null, 'fixed-width', null, true);
                            break;
                        case InsuranceParamType.Price:
                            var priceObject = new PriceEditorModel();
                            priceObject.removeTaxTypes = true;
                            priceObject.price = { id: param.paramObject?.price?.id, value: param.paramValue ? parseFloat(param.paramValue) : 0 };
                            priceObject.taxType = { id: param.paramObject?.taxType?.id, value: param.paramObject?.taxType?.value };
                            priceObject.mode = param.paramObject.mode;
                            priceObject.currency = { id: param.paramObject?.currency?.id, value: param.paramObject?.currency?.value };
                            priceObject.taxRate = { id: param.paramObject?.taxRate?.id, value: param.paramObject?.taxRate?.value };
                            priceObject.taxAmount = { id: param.paramObject?.taxAmount?.id, value: param.paramObject?.taxAmount?.value };
                            field = new FieldModel(param.paramLabel, param.paramValue, "price", param.paramId, true, param.paramIsMandatory, priceObject);
                            break;
                        case InsuranceParamType.DisplayText:
                            field = new FieldModel(param.paramLabel, param.paramValue, "text", param.paramId, false, false);
                            break;
                        case InsuranceParamType.Checkbox:
                            field = new FieldModel(param.paramLabel, param.paramValue, "boolean", param.paramId, true, true);
                            break;
                        default:
                            field = new FieldModel(param.paramLabel, param.paramValue, "text", param.paramId, false, false, null, null, null, true);
                            break;
                    }

                    if (param.paramHasChildren)
                    {
                        field.hasChildren = true;
                    }
                    if (param.paramParentId)
                    {
                        field.parent = param.paramParentId;
                        field.toggleEditableWhen = param.paramEditableWhen;
                        field.editable = param.paramIsEditable;
                    }

                    switch (param.paramGroup)
                    {
                        case InsuranceParamGroup.ResponsibleLendingCodeTermsConditions:
                            responsibleLendingCodeTermsConditions.addField(field);
                            break;
                        case InsuranceParamGroup.CustomerInformation:
                            customerInformation.addField(field);
                            break;
                        case InsuranceParamGroup.CustomerDisclosure:
                            customerDisclosure.addField(field);
                            break;
                        case InsuranceParamGroup.VehicleInformation:
                            vehicleInformation.addField(field);
                            break;
                        case InsuranceParamGroup.FinanceInsuranceInformation:
                            financeInsuranceInformation.addField(field);
                            break;
                        case InsuranceParamGroup.PaymentDetails:
                            paymentDetails.addField(field);
                            break;
                        case InsuranceParamGroup.Drivers:
                            drivers.addField(field);
                            break;
                        case InsuranceParamGroup.GeneralQuestions:
                            generalQuestions.addField(field);
                            break;
                        case InsuranceParamGroup.AdditionalQuestions:
                            additionalQuestions.addField(field);
                            break;
                    }


                }

                if (responsibleLendingCodeTermsConditions.fields.length > 0)
                    field_groups.push(responsibleLendingCodeTermsConditions);
                if (customerInformation.fields.length > 0)
                    field_groups.push(customerInformation);
                if (customerDisclosure.fields.length > 0)
                    field_groups.push(customerDisclosure);
                if (vehicleInformation.fields.length > 0)
                    field_groups.push(vehicleInformation);
                if (financeInsuranceInformation.fields.length > 0)
                    field_groups.push(financeInsuranceInformation);
                if (paymentDetails.fields.length > 0)
                    field_groups.push(paymentDetails);
                if (drivers.fields.length > 0)
                    field_groups.push(drivers);
                if (generalQuestions.fields.length > 0)
                    field_groups.push(generalQuestions);
                if (additionalQuestions.fields.length > 0)
                    field_groups.push(additionalQuestions);                
                
                break;

        }
        return field_groups;
    }

    getListItemFromLookupExternal(lookups: LookupExternalModel[]): ListItemModel[]
    {
        let listItems: ListItemModel[] = [];
        for (let lookup of lookups)
        {
            listItems.push(new ListItemModel(lookup.id, lookup.caption));
        }
        return listItems;
    }

    public async setupProductQuoteFieldGroups(productQuote: ProductQuoteModel, makeDirty: boolean = false): Promise<TabModel[]>
    {

        var fieldGroupTabs: TabModel[] = [];

        if (this.userService.hasUserRight(SecurityRight.Reports))
        {
            fieldGroupTabs.push(new TabModel("General", productQuote, await this.getProductQuoteFieldGroups(productQuote, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.SaleTabsFinanceView), this.userService.hasUserRight(SecurityRight.SaleTabsFinanceEdit)));
        }

        return fieldGroupTabs;
    }

    public async getProductQuoteFieldGroups(productQuote: ProductQuoteModel, groupId: string): Promise<FieldGroupModel[]> {
        var field_groups = [];
        var group: FieldGroupModel;
        var selectedProduct = productQuote.mviQuote.selectedProduct;

        switch (groupId)
        {
            case "General":
                group = new FieldGroupModel("Select product");
                group.singleColumn = true;
                var options = [];
                for (let option of productQuote.mviQuote.products)
                {
                    var description = option.productDescription + " • " + this.getPriceDisplay(option.saleAmount, false) + " • " + this.getPriceDisplay(option.standardExcess, false, false) + " Excess";
                    options.push(new ListItemModel(option.id, description));
                }
                var product = new FieldModel("Product", productQuote.mviQuote.selectedProductId, "select", "selectedProductId", true, true, options);
                product.hasChildren = true;
                group.addField(product);
                field_groups.push(group);


                if (selectedProduct != null)
                {
                    group = new FieldGroupModel("Options");
                    group.singleColumn = true;
                    if (selectedProduct.roadsideAssistance != null)
                    {
                        group.addField(new FieldModel("Roadside assistance (" + this.getPriceDisplay(selectedProduct.roadsideAssistance.value) + ")", productQuote.mviFields.hasRoadsideAssistance, "toggle", "hasRoadsideAssistance", true, false));
                    }
                    if (selectedProduct.windscreenCover != null)
                    {
                        group.addField(new FieldModel("Windscreen cover (" + this.getPriceDisplay(selectedProduct.windscreenCover.value) + ")", productQuote.mviFields.hasWindscreenCover, "toggle", "hasWindscreenCover", true, false));
                    }
                    if (selectedProduct.excludeDriversUnder25 != null)
                    {
                        group.addField(new FieldModel("Exclude drivers younger than 25 (" + this.getPriceDisplay(selectedProduct.excludeDriversUnder25.value) + ")", productQuote.mviFields.excludeDriversUnder25, "toggle", "excludeDriversUnder25", true, false));
                    }
                    if (selectedProduct.allowNamedDriversOnly != null)
                    {
                        group.addField(new FieldModel("Named drivers only (" + this.getPriceDisplay(selectedProduct.allowNamedDriversOnly.value) + ")", productQuote.mviFields.allowNamedDriversOnly, "toggle", "allowNamedDriversOnly", true, false));    
                    }
                    if (selectedProduct.noClaimsBonusProtection != null)
                    {
                        group.addField(new FieldModel("No claims bonus protection (" + this.getPriceDisplay(selectedProduct.noClaimsBonusProtection.value) + ")", productQuote.mviFields.hasNoClaimsBonusProtection, "toggle", "hasNoClaimsBonusProtection", true, false));
                    }
                    
                    if (selectedProduct.voluntaryExcesses != null && selectedProduct.voluntaryExcesses.length > 0)
                    {
                        var voluntaryOptions = [];
                        for (let excess of selectedProduct.voluntaryExcesses)
                        {
                            var description = this.getPriceDisplay(excess.excess, true, false) + " (" + this.getPriceDisplay(excess.value) + ")";
                            voluntaryOptions.push(new ListItemModel(excess.excess.toString(), description));
                        }
                        var voluntExcess = new FieldModel("Voluntary additional excess", productQuote.mviFields.voluntaryExcessAmount, "select", "voluntaryAdditionalExcess", true, false, voluntaryOptions);
                        voluntExcess.allowClear = true;
                        group.addField(voluntExcess);
                    }
                    if (selectedProduct.rentalCarExcesses != null && selectedProduct.rentalCarExcesses.length > 0)
                    {
                        var rentalExpress = [];
                        for (let excess of selectedProduct.rentalCarExcesses)
                        {
                            var description = this.getPriceDisplay(excess.excess, true, false) + " (" + this.getPriceDisplay(excess.value) + ")";
                            rentalExpress.push(new ListItemModel(excess.excess.toString(), description));
                        }
                        var rentalExcess = new FieldModel("Rental car excess", productQuote.mviFields.rentalCarExcessAmount, "select", "rentalCarExcess", true, false, rentalExpress);
                        rentalExcess.allowClear = true;
                        group.addField(rentalExcess);
                    }
                    if (group.fields.length > 0)
                    {
                        field_groups.push(group);
                    }
                }


                group = new FieldGroupModel("Summary");
                group.singleColumn = true;
                var paymentOptions = productQuote.mviQuote.paymentMethod.map(option => new ListItemModel(option.id, option.caption));
                group.addField(new FieldModel("Payment method", productQuote.mviFields.paymentMethodId, "select", "paymentMethodId", true, true, paymentOptions));
                if (selectedProduct != null)
                {
                    group.addField(new FieldModel("Final premium", productQuote.mviFields.quoteSaleAmount, "currency", "quoteSaleAmount", false, false, null, null, null, true));
                }
                if (selectedProduct != null && selectedProduct.isImmobilizerRequired)
                {
                    group.addField(new FieldModel("This vehicle must be fitted with an immobiliser to be covered against theft by this policy. Please confirm that you agree to these terms.", productQuote.mviFields.isImmobilizerConfirmed, "toggle", "immobiliserConfirmed", true, false));
                }
                field_groups.push(group);

                break;

        }
        return field_groups;
    }

    getPriceDisplay(price: number, showPlusMinus: boolean = true, perYearLabel: boolean = true): string
    {
        if (price <= 0)
        {
            return (showPlusMinus ? "-" : "")  + "$" + Math.abs(price).toFixed(2) + (perYearLabel ? " per year" : "");
        }
        else
        {
            return (showPlusMinus ? "+" : "") + "$" + price.toFixed(2) + (perYearLabel ? " per year" : "");
        }
    }

    calculateQuoteAmount(productQuote: ProductQuoteModel): Observable<number>
    {
        return this.httpClient.post<number>(Constants.ApiUrl + 'Insurances/CalculateQuoteAmount', productQuote);
    }

    validateCanSetSaleInProgress(saleId: string): Observable<string>
    {
        return this.httpClient.get<string>(Constants.ApiUrl + 'Sales/' + saleId + '/ValidateCanSetInProgress');
    }
}
